import { atom } from 'recoil';
import { FilterDef } from '../../../constants/FinanceModels';

export const STATE_TABLE_UPDATING = atom<boolean>({
    key: "amex-cards-state-table-updating",
    default: false
});

export const STATE_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'amex-cards-state-active-filters',
    default: []
});